// NPM Imports
import React, { Component } from "react";
import moment from "moment";
import Modal from "react-responsive-modal";
import { Loader, Button, Label } from "@revvsales/components";

// Components Imports
import {
  DateSelect,
  ReactSelect,
  SearchableSelect,
} from "../../../commonComponents";

// Internal Imports
import { PIPELINE } from "../../../constants";
import { UserActions } from "../../../actions";

// Destructuring
const { loadOwnerData } = UserActions;
const { DATE_FILTERS } = PIPELINE;

class PipelineFilterPopup extends Component {
  _handleChangeInSelect = value => {
    this.props.updateState("ownerFilters", value);
  };

  _promiseOption = inputValue =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve(this._loadOptionForOwner(inputValue));
      }, 1000);
    });

  _loadOptionForOwner = async inputValue => {
    let result = [];
    if (inputValue) {
      await loadOwnerData(inputValue).then(data => {
        result = data.users;
      });
      return result;
    }
    return [];
  };

  _makeStageBtnClass = name => {
    if (this.props.stageFilters.includes(name)) {
      return "btn btn-info btn-sm pipelinefilterpopup-stagefilter-btn";
    }
    return "btn btn-default btn-sm pipelinefilterpopup-stagefilter-btn";
  };

  render() {
    const { show, closePopup } = this.props;
    const startDateSelectSpace =
      this.props.dateFilterType === "None" ? (
        <input
          type="text"
          className="form-control"
          disabled
          value="--/--/----"
        />
      ) : (
        <DateSelect
          passDefaultDate
          selectedDate={moment(this.props.customStartDate)}
          returnValue={date =>
            this.props.updateState(
              "customStartDate",
              moment(date).format("YYYY-MM-DD"),
            )
          }
          disabled={!this.props.customDateFilter}
        />
      );
    const endDateSelectSpace =
      this.props.dateFilterType === "None" ? (
        <input
          type="text"
          className="form-control"
          disabled
          value="--/--/----"
        />
      ) : (
        <DateSelect
          passDefaultDate
          selectedDate={moment(this.props.customEndDate)}
          returnValue={date =>
            this.props.updateState(
              "customEndDate",
              moment(date).format("YYYY-MM-DD"),
            )
          }
          disabled={!this.props.customDateFilter}
        />
      );

    return (
      <Modal
        open={show}
        onClose={closePopup}
        center
        closeOnOverlayClick={false}
        className="pipelinefilterpopup-wrapper">
        {this.props.showFilterBtnLoader ? (
          <div className="pipelinefilterpopup-loader-wrapper">
            <Loader />
          </div>
        ) : null}
        <div className="row">
          <div className="col-md-12">
            <div className="popup-form pipelinefilterpopup-wrapper">
              <h3>Filter Opportunities</h3>
              <div className="pipelinefilterpopup-item">
                <Label className="pipelinefilterpopup-checkbox">
                  <span className="pipelinefilterpopup-filter-heading">
                    Filter by Account
                  </span>
                  {this.props.accountFilter && (
                    <span
                      className="pipelinefilterpopup-clear-btn"
                      onClick={() => this.props.clearFilters(1)}
                      onKeyPress={() => {}}
                      role="button"
                      tabIndex="-1">
                      (Clear)
                    </span>
                  )}
                </Label>
                <div className="pipelinefilterpopup-content">
                  <ReactSelect
                    value={this.props.accountFilter.label}
                    onChange={this.props.setAccountFilter}
                    options={this.props.accountList}
                    valueKey="id"
                    labelKey="name"
                    data-test="pipelinefilterpopup-name-select"
                  />
                </div>
              </div>
              <div className="pipelinefilterpopup-item">
                <Label className="pipelinefilterpopup-checkbox">
                  <span className="pipelinefilterpopup-filter-heading">
                    Filter by Owner
                  </span>
                  {this.props.ownerFilters.length > 0 && (
                    <span
                      className="pipelinefilterpopup-clear-btn"
                      onClick={() => this.props.clearFilters(2)}
                      onKeyPress={() => {}}
                      role="button"
                      tabIndex="-1">
                      (Clear)
                    </span>
                  )}
                </Label>
                <div className="pipelinefilterpopup-content">
                  <SearchableSelect
                    getOptionLabel={({ name }) => name}
                    promiseOption={this._promiseOption}
                    value={this.props.ownerFilters}
                    isMulti
                    _handleChangeInSelect={this._handleChangeInSelect}
                    placeholder="Type user email"
                  />
                </div>
              </div>
              <div className="pipelinefilterpopup-item line">
                <Label className="pipelinefilterpopup-checkbox">
                  <span className="pipelinefilterpopup-filter-heading">
                    Filter by last updated date
                  </span>
                  {this.props.dateFilterType !== "None" && (
                    <span
                      className="pipelinefilterpopup-clear-btn"
                      onClick={() => this.props.clearFilters(3)}
                      onKeyPress={() => {}}
                      role="button"
                      tabIndex="-1">
                      (Clear)
                    </span>
                  )}
                </Label>
                <div className="pipelinefilterpopup-content">
                  <div>
                    {DATE_FILTERS.map(filterItem => (
                      <Label
                        className="pipelinefilterpopup-radio"
                        key={filterItem}>
                        <input
                          type="radio"
                          name="optradio"
                          checked={this.props.dateFilterType === filterItem}
                          onChange={() =>
                            this.props.setDateFilterType(filterItem)
                          }
                          data-test="pipelinefilterpopup-type-radio"
                        />
                        &nbsp;&nbsp;{filterItem}
                      </Label>
                    ))}
                  </div>
                  <div className="form-row">
                    <div className="form-group col-md-6">
                      <Label htmlFor="exampleInputEmail2">Start Date</Label>
                      <div className="dateselect">{startDateSelectSpace}</div>
                    </div>
                    <div className="form-group col-md-6">
                      <Label htmlFor="exampleInputEmail4">End Date</Label>
                      <br />
                      <div className="dateselect">{endDateSelectSpace}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="pipelinefilterpopup-item line">
                <Label className="pipelinefilterpopup-checkbox">
                  <span className="pipelinefilterpopup-filter-heading">
                    Filter by Opportunity Stage
                  </span>
                  {this.props.stageFilters.length > 0 && (
                    <span
                      className="pipelinefilterpopup-clear-btn"
                      onClick={() => this.props.clearFilters(4)}
                      onKeyPress={() => {}}
                      role="button"
                      tabIndex="-2">
                      (Clear)
                    </span>
                  )}
                </Label>
                <div className="pipelinefilterpopup-content">
                  {this.props.oppoStages.map(stage => (
                    <Button
                      className={this._makeStageBtnClass(stage.name)}
                      key={stage.name}
                      onClick={() =>
                        this.props.setOppoStagesFilters(stage.name)
                      }
                      data-test="pipelinefilterpopup-stagename-btn">
                      {stage.name}
                    </Button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pipelinefilterpopup-footer popup-footer">
          <Button
            className="btn btn-transparent pipelinefilterpopup-footer-cancelbtn pipelinefilterpopup-clearallbtn"
            onClick={() => this.props.clearFilters(5)}
            data-test="pipelinefilterpopup-clear-btn">
            Clear All Filters
          </Button>
          <div className="pipelinefilterpopup-footer-actions">
            <Button
              className="btn btn-transparent pipelinefilterpopup-footer-cancelbtn"
              onClick={closePopup}
              data-test="pipelinefilterpopup-cancel-btn">
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={this.props.submitFilters}
              data-test="pipelinefilterpopup-filter-btn">
              Filter
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default PipelineFilterPopup;



// WEBPACK FOOTER //
// ./src/components/PipelineWrapper/PipelineFilterPopup/index.js